export const salesAssistantCareDe = {
  title: 'Kundenpflege',
  headerDueTasks: '{{count}} heute fällige oder überfällige persönliche Vertriebsaufgaben',
  status: {
    NEEDS_ATTENTION: 'Aufmerksamkeit erforderlich',
    PLANNED: 'Kontakt geplant',
    ON_TRACK: 'Im Plan',
    BLOCKED: 'Gesperrt',
    EXCLUDED: 'Automatik ausgenommen',
    INSUFFICIENT_DATA: 'Noch wenig Daten',
  },
  error: 'Die Kundenpflege-Daten konnten nicht geladen werden.',
  lastOrder: 'Letzte Bestellung',
  lastContact: 'Letzter persönlicher Kontakt',
  lastSuccessfulCall: 'Letzter erfolgreicher Telefonkontakt',
  nextContact: 'Nächster geplanter Kontakt',
  expectedOrder: 'Erwartete nächste Bestellung',
  rhythm: 'Üblicher Bestellrhythmus',
  openRecommendations: 'Offene Empfehlungen',
  openTasks: 'Offene Vertriebsaufgaben',
  owner: 'Zuständig',
  contactBlocked: 'Kontaktsperre',
  marketingBlocked: 'Werbekontakt gesperrt',
  documentContact: 'Kontakt dokumentieren',
  planCallback: 'Rückruf planen',
  createTask: 'Aufgabe erstellen',
  planVisit: 'Besuch planen',
  createQuote: 'Angebot erstellen',
  changeInterval: 'Intervalle ändern',
  manageExclusions: 'Regeln ausnehmen',
  openAssistant: 'Im Vertriebsassistenten öffnen',
  taskDialogTitle: 'Vertriebsaufgabe planen',
  taskReasons: {
    CALLBACK: 'Vereinbarten Rückruf durchführen',
    FOLLOW_UP: 'Kundenpflege strukturiert fortsetzen',
    VISIT: 'Außendienstbesuch vorbereiten',
  },
  taskTitles: {
    CALLBACK: 'Kundenrückruf',
    FOLLOW_UP: 'Kundenpflege-Wiedervorlage',
    VISIT: 'Außendienstbesuch',
  },
  settingsTitle: 'Betreuungs- und Bestellintervalle',
  settingsDescription:
    'Individuelle Werte überschreiben die nachvollziehbaren Mandanten- und Segmentregeln.',
  careInterval: 'Persönlicher Kontakt spätestens nach Tagen',
  orderInterval: 'Bestellintervall in Tagen',
  plannedOrder: 'Bereits geplante Bestellung',
  excludeCadence: 'Bestellrhythmus-Automatik ausnehmen',
  excludeCadenceHelp:
    'Für diesen Kunden werden keine reaktivierenden Rhythmus-Empfehlungen erzeugt.',
  settingsSaved: 'Kundenpflege-Einstellungen gespeichert.',
  exclusionsTitle: 'Automatische Regeln ausnehmen',
  exclusionsDescription: 'Wähle nur Regeln aus, die für diesen Kunden dauerhaft unpassend sind.',
  exclusionReason: 'Nachvollziehbarer Grund',
  exclusionsSaved: 'Regelausschlüsse gespeichert.',
} as const;

export const salesAssistantCareEn = {
  title: 'Customer care',
  headerDueTasks: '{{count}} personal sales tasks due today or overdue',
  status: {
    NEEDS_ATTENTION: 'Attention required',
    PLANNED: 'Contact planned',
    ON_TRACK: 'On track',
    BLOCKED: 'Blocked',
    EXCLUDED: 'Excluded from automation',
    INSUFFICIENT_DATA: 'Limited data',
  },
  error: 'Customer-care data could not be loaded.',
  lastOrder: 'Last order',
  lastContact: 'Last personal contact',
  lastSuccessfulCall: 'Last successful phone contact',
  nextContact: 'Next planned contact',
  expectedOrder: 'Expected next order',
  rhythm: 'Typical reorder cadence',
  openRecommendations: 'Open recommendations',
  openTasks: 'Open sales tasks',
  owner: 'Owner',
  contactBlocked: 'Contact blocked',
  marketingBlocked: 'Marketing contact blocked',
  documentContact: 'Document contact',
  planCallback: 'Plan callback',
  createTask: 'Create task',
  planVisit: 'Plan visit',
  createQuote: 'Create quote',
  changeInterval: 'Change intervals',
  manageExclusions: 'Exclude rules',
  openAssistant: 'Open in sales assistant',
  taskDialogTitle: 'Plan sales task',
  taskReasons: {
    CALLBACK: 'Complete the agreed callback',
    FOLLOW_UP: 'Continue customer care in a structured way',
    VISIT: 'Prepare a field visit',
  },
  taskTitles: {
    CALLBACK: 'Customer callback',
    FOLLOW_UP: 'Customer-care follow-up',
    VISIT: 'Field visit',
  },
  settingsTitle: 'Care and reorder intervals',
  settingsDescription: 'Individual values override the explainable tenant and segment rules.',
  careInterval: 'Personal contact after days at the latest',
  orderInterval: 'Reorder interval in days',
  plannedOrder: 'Order already planned',
  excludeCadence: 'Exclude from cadence automation',
  excludeCadenceHelp:
    'No cadence-based reactivation recommendations will be created for this customer.',
  settingsSaved: 'Customer-care settings saved.',
  exclusionsTitle: 'Exclude automatic rules',
  exclusionsDescription: 'Select only rules that are permanently unsuitable for this customer.',
  exclusionReason: 'Documented reason',
  exclusionsSaved: 'Rule exclusions saved.',
} as const;

export const salesAssistantCareTr = {
  title: 'Müşteri bakımı',
  headerDueTasks: 'Bugün süresi dolan veya geciken {{count}} kişisel satış görevi',
  status: {
    NEEDS_ATTENTION: 'İlgi gerekiyor',
    PLANNED: 'İletişim planlandı',
    ON_TRACK: 'Planında',
    BLOCKED: 'Engelli',
    EXCLUDED: 'Otomasyon dışında',
    INSUFFICIENT_DATA: 'Veri yetersiz',
  },
  error: 'Müşteri bakım verileri yüklenemedi.',
  lastOrder: 'Son sipariş',
  lastContact: 'Son kişisel iletişim',
  lastSuccessfulCall: 'Son başarılı telefon görüşmesi',
  nextContact: 'Planlanan sonraki iletişim',
  expectedOrder: 'Beklenen sonraki sipariş',
  rhythm: 'Tipik sipariş ritmi',
  openRecommendations: 'Açık öneriler',
  openTasks: 'Açık satış görevleri',
  owner: 'Sorumlu',
  contactBlocked: 'İletişim engeli',
  marketingBlocked: 'Pazarlama iletişimi engelli',
  documentContact: 'İletişimi kaydet',
  planCallback: 'Geri arama planla',
  createTask: 'Görev oluştur',
  planVisit: 'Ziyaret planla',
  createQuote: 'Teklif oluştur',
  changeInterval: 'Aralıkları değiştir',
  manageExclusions: 'Kuralları hariç tut',
  openAssistant: 'Satış asistanında aç',
  taskDialogTitle: 'Satış görevi planla',
  taskReasons: {
    CALLBACK: 'Kararlaştırılan geri aramayı yap',
    FOLLOW_UP: 'Müşteri bakımını planlı sürdür',
    VISIT: 'Saha ziyaretini hazırla',
  },
  taskTitles: {
    CALLBACK: 'Müşteri geri araması',
    FOLLOW_UP: 'Müşteri bakım takibi',
    VISIT: 'Saha ziyareti',
  },
  settingsTitle: 'Bakım ve sipariş aralıkları',
  settingsDescription:
    'Müşteriye özel değerler açıklanabilir şirket ve segment kurallarının önüne geçer.',
  careInterval: 'En geç kaç gün sonra kişisel iletişim',
  orderInterval: 'Gün olarak sipariş aralığı',
  plannedOrder: 'Planlanmış sipariş',
  excludeCadence: 'Sipariş ritmi otomasyonından çıkar',
  excludeCadenceHelp: 'Bu müşteri için ritme dayalı yeniden etkinleştirme önerisi oluşturulmaz.',
  settingsSaved: 'Müşteri bakım ayarları kaydedildi.',
  exclusionsTitle: 'Otomatik kurallardan çıkar',
  exclusionsDescription: 'Yalnızca bu müşteri için kalıcı olarak uygun olmayan kuralları seçin.',
  exclusionReason: 'Belgelenmiş neden',
  exclusionsSaved: 'Kural istisnaları kaydedildi.',
} as const;

export const salesAssistantCareFr = {
  title: 'Suivi client',
  headerDueTasks: '{{count}} tâches commerciales personnelles dues aujourd’hui ou en retard',
  status: {
    NEEDS_ATTENTION: 'Attention requise',
    PLANNED: 'Contact planifié',
    ON_TRACK: 'Dans les temps',
    BLOCKED: 'Bloqué',
    EXCLUDED: 'Exclu de l’automatisation',
    INSUFFICIENT_DATA: 'Données limitées',
  },
  error: 'Les données de suivi client n’ont pas pu être chargées.',
  lastOrder: 'Dernière commande',
  lastContact: 'Dernier contact personnel',
  lastSuccessfulCall: 'Dernier appel réussi',
  nextContact: 'Prochain contact planifié',
  expectedOrder: 'Prochaine commande attendue',
  rhythm: 'Rythme de commande habituel',
  openRecommendations: 'Recommandations ouvertes',
  openTasks: 'Tâches commerciales ouvertes',
  owner: 'Responsable',
  contactBlocked: 'Contact interdit',
  marketingBlocked: 'Contact marketing interdit',
  documentContact: 'Documenter le contact',
  planCallback: 'Planifier un rappel',
  createTask: 'Créer une tâche',
  planVisit: 'Planifier une visite',
  createQuote: 'Créer un devis',
  changeInterval: 'Modifier les intervalles',
  manageExclusions: 'Exclure des règles',
  openAssistant: 'Ouvrir dans l’assistant commercial',
  taskDialogTitle: 'Planifier une tâche commerciale',
  taskReasons: {
    CALLBACK: 'Effectuer le rappel convenu',
    FOLLOW_UP: 'Poursuivre le suivi client de façon structurée',
    VISIT: 'Préparer une visite terrain',
  },
  taskTitles: { CALLBACK: 'Rappel client', FOLLOW_UP: 'Suivi client', VISIT: 'Visite terrain' },
  settingsTitle: 'Intervalles de suivi et de commande',
  settingsDescription:
    'Les valeurs individuelles remplacent les règles explicables du tenant et du segment.',
  careInterval: 'Contact personnel au plus tard après (jours)',
  orderInterval: 'Intervalle de commande en jours',
  plannedOrder: 'Commande déjà planifiée',
  excludeCadence: 'Exclure de l’automatisation du rythme',
  excludeCadenceHelp:
    'Aucune recommandation de réactivation liée au rythme ne sera créée pour ce client.',
  settingsSaved: 'Paramètres de suivi enregistrés.',
  exclusionsTitle: 'Exclure des règles automatiques',
  exclusionsDescription: 'Sélectionnez uniquement les règles durablement inadaptées à ce client.',
  exclusionReason: 'Motif documenté',
  exclusionsSaved: 'Exclusions de règles enregistrées.',
} as const;

export const salesAssistantCareEs = {
  title: 'Atención al cliente',
  headerDueTasks: '{{count}} tareas comerciales personales para hoy o atrasadas',
  status: {
    NEEDS_ATTENTION: 'Requiere atención',
    PLANNED: 'Contacto planificado',
    ON_TRACK: 'Según lo previsto',
    BLOCKED: 'Bloqueado',
    EXCLUDED: 'Excluido de automatización',
    INSUFFICIENT_DATA: 'Datos limitados',
  },
  error: 'No se pudieron cargar los datos de atención al cliente.',
  lastOrder: 'Último pedido',
  lastContact: 'Último contacto personal',
  lastSuccessfulCall: 'Última llamada exitosa',
  nextContact: 'Próximo contacto planificado',
  expectedOrder: 'Próximo pedido esperado',
  rhythm: 'Ritmo habitual de pedidos',
  openRecommendations: 'Recomendaciones abiertas',
  openTasks: 'Tareas comerciales abiertas',
  owner: 'Responsable',
  contactBlocked: 'Contacto bloqueado',
  marketingBlocked: 'Contacto comercial bloqueado',
  documentContact: 'Documentar contacto',
  planCallback: 'Planificar devolución',
  createTask: 'Crear tarea',
  planVisit: 'Planificar visita',
  createQuote: 'Crear oferta',
  changeInterval: 'Cambiar intervalos',
  manageExclusions: 'Excluir reglas',
  openAssistant: 'Abrir en el asistente de ventas',
  taskDialogTitle: 'Planificar tarea comercial',
  taskReasons: {
    CALLBACK: 'Realizar la devolución acordada',
    FOLLOW_UP: 'Continuar la atención de forma estructurada',
    VISIT: 'Preparar una visita comercial',
  },
  taskTitles: {
    CALLBACK: 'Devolución al cliente',
    FOLLOW_UP: 'Seguimiento del cliente',
    VISIT: 'Visita comercial',
  },
  settingsTitle: 'Intervalos de atención y pedidos',
  settingsDescription:
    'Los valores individuales sustituyen las reglas explicables del tenant y segmento.',
  careInterval: 'Contacto personal como máximo tras días',
  orderInterval: 'Intervalo de pedidos en días',
  plannedOrder: 'Pedido ya planificado',
  excludeCadence: 'Excluir de automatización del ritmo',
  excludeCadenceHelp: 'No se crearán recomendaciones de reactivación por ritmo para este cliente.',
  settingsSaved: 'Ajustes de atención guardados.',
  exclusionsTitle: 'Excluir reglas automáticas',
  exclusionsDescription:
    'Selecciona solo reglas que no sean apropiadas de forma permanente para este cliente.',
  exclusionReason: 'Motivo documentado',
  exclusionsSaved: 'Exclusiones guardadas.',
} as const;

export const salesAssistantCareRu = {
  title: 'Работа с клиентом',
  headerDueTasks: '{{count}} личных задач продаж на сегодня или просрочено',
  status: {
    NEEDS_ATTENTION: 'Требует внимания',
    PLANNED: 'Контакт запланирован',
    ON_TRACK: 'По плану',
    BLOCKED: 'Заблокировано',
    EXCLUDED: 'Исключено из автоматизации',
    INSUFFICIENT_DATA: 'Мало данных',
  },
  error: 'Не удалось загрузить данные по работе с клиентом.',
  lastOrder: 'Последний заказ',
  lastContact: 'Последний личный контакт',
  lastSuccessfulCall: 'Последний успешный звонок',
  nextContact: 'Следующий запланированный контакт',
  expectedOrder: 'Ожидаемый следующий заказ',
  rhythm: 'Обычный ритм заказов',
  openRecommendations: 'Открытые рекомендации',
  openTasks: 'Открытые задачи продаж',
  owner: 'Ответственный',
  contactBlocked: 'Контакты запрещены',
  marketingBlocked: 'Маркетинговые контакты запрещены',
  documentContact: 'Зафиксировать контакт',
  planCallback: 'Запланировать звонок',
  createTask: 'Создать задачу',
  planVisit: 'Запланировать визит',
  createQuote: 'Создать предложение',
  changeInterval: 'Изменить интервалы',
  manageExclusions: 'Исключить правила',
  openAssistant: 'Открыть в ассистенте продаж',
  taskDialogTitle: 'Запланировать задачу продаж',
  taskReasons: {
    CALLBACK: 'Выполнить согласованный звонок',
    FOLLOW_UP: 'Продолжить структурированную работу с клиентом',
    VISIT: 'Подготовить выездной визит',
  },
  taskTitles: {
    CALLBACK: 'Звонок клиенту',
    FOLLOW_UP: 'Повторный контакт с клиентом',
    VISIT: 'Выездной визит',
  },
  settingsTitle: 'Интервалы контактов и заказов',
  settingsDescription: 'Индивидуальные значения заменяют объяснимые правила компании и сегмента.',
  careInterval: 'Личный контакт не позднее чем через дней',
  orderInterval: 'Интервал заказов в днях',
  plannedOrder: 'Уже запланированный заказ',
  excludeCadence: 'Исключить из анализа ритма',
  excludeCadenceHelp: 'Для этого клиента не будут создаваться рекомендации реактивации по ритму.',
  settingsSaved: 'Настройки работы с клиентом сохранены.',
  exclusionsTitle: 'Исключить автоматические правила',
  exclusionsDescription: 'Выберите только правила, которые постоянно не подходят этому клиенту.',
  exclusionReason: 'Зафиксированная причина',
  exclusionsSaved: 'Исключения правил сохранены.',
} as const;
